import '@vuepic/vue-datepicker/dist/main.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-slider-component/theme/default.css'
import 'url-polyfill'
import './assets/styles/index.scss'

import clickOutsideDirective from '@sancare/typescript-commons/src/misc/click-outside'
import { reportClientInfo } from '@sancare/typescript-commons/src/misc/client-info'
import FloatingVue from 'floating-vue'
import { createApp } from 'vue'

import { useRouter } from '@/router'

import i18n from './i18n'
import SancareApp from './SancareApp.vue'
import store from './store'

const app = createApp(SancareApp)
app.use(i18n)
app.use(store)
app.use(useRouter(true))
app.use(FloatingVue)
app.directive('on-click-outside', clickOutsideDirective)
app.directive('focus', {
  mounted: (el) => el.focus()
})
app.mount('#sancare-app')
// see: https://app.clickup.com/t/2628858/SANC-338
reportClientInfo()
